// ///////////////////////////////////////////
// Dependencies

import React from 'react';
import PropTypes from 'prop-types';

import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const UIView = MojitoCore.Presentation.UIView;
const Image = MojitoPresentation.Components.Image;

// ///////////////////////////////////////////
// Implementation

class TextViewImpl extends UIViewImplementation {
    constructor(props) {
        super(props);
    }

    renderHeader() {
        if (!this.props.header) {
            return;
        }

        return (
            <div style={this.style.header} key="header" className="ta-TextViewHeader">
                <div>{this.props.header}</div>
                {this.renderPrintButton()}
            </div>
        );
    }

    renderPrintButtonText() {
        if (this.config.printButton && this.config.printButton.hide) {
            return null;
        }
        return (
            <div style={this.style.printButtonText}>{this.resolveString('$DOWNLOAD_BET_PDF_BUTTON.BUTTON_TEXT')}</div>
        );
    }

    renderPrintButton() {
        if (!this.props.downloadLink) return null;
        return (
            <a style={this.style.printButtonContainer} href={this.props.downloadLink} download>
                {this.renderPrintButtonText(0)}
                <Image config={this.style.image} alt="print" />
            </a>
        );
    }

    renderText() {
        if (!this.props.text) {
            return;
        }

        return (
            <div style={this.style.textArea} key="text" className="text">
                {this.renderHtmlStr(this.props.text)}
            </div>
        );
    }

    renderHtmlStr(str) {
        const innerHtml = {
            __html: str,
        };

        return <span dangerouslySetInnerHTML={innerHtml} />;
    }

    render() {
        return (
            <div style={this.style.content} className="ta-TextView">
                {this.renderHeader()}
                {this.renderText()}
            </div>
        );
    }
}

TextViewImpl.propTypes = {
    header: PropTypes.string,
    text: PropTypes.string,
    downloadLink: PropTypes.string,
};

// ///////////////////////////////////////////
// Styling

TextViewImpl.getStyle = function (config, applicationMode, merge) {
    return {
        content: merge(config.content.borderStyle, {
            background: config.content.background,
            margin: config.content.margin,
            padding: config.content.padding,
        }),
        header: merge(config.header.textStyle, config.header.borderStyle, {
            background: config.header.background,
            margin: config.header.margin,
            padding: config.header.padding,
            display: 'flex',
            flexFlow: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        }),
        textArea: merge(config.textArea.textStyle, config.textArea.borderStyle, {
            background: config.textArea.background,
            padding: config.textArea.padding,
            margin: config.textArea.margin,
        }),
        printButtonContainer: merge(
            {
                textDecoration: 'none',
                display: 'flex',
                flexFlow: 'row',
                justifyContent: 'center',
                width: '82px',
                height: '32px',
                borderRadius: '2px',
                background: '#ffffff',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#a6abb1',
                cursor: 'pointer',
            },
            config.printButton && config.printButton.container ? config.printButton.container : {}
        ),
        printButtonText: merge(
            {
                fontSize: '12px',
                color: '#003769',
                alignSelf: 'center',
                margin: '0 8px 0 0',
            },
            config.printButton && config.printButton.text ? config.printButton.text : {}
        ),
        image: merge(
            {
                src: 'print',
                style: {
                    width: '16px',
                    height: '16px',
                    alignSelf: 'center',
                },
            },
            config.printButton && config.printButton.image ? config.printButton.image : {}
        ),
    };
};

export const TextView = UIView('TextView', TextViewImpl, TextViewImpl.propTypes);
